export default __webpack_public_path__ + "static/media/011-worry.cfea45e3.svg";